import TableCell from "../common/ui/TableCell";

export default function MaterialGRView({ data }) {
  const header = data.header || {};
  const items = data.items || data.lines || [];

  const fmtDate = (v) => {
    if (!v) return "-";
    const d = new Date(v);
    return isNaN(d) ? String(v) : d.toLocaleDateString();
  };

  const columns = [
    { key: "code", label: "코드" },
    { key: "name", label: "품명" },
    { key: "spec", label: "규격" },
    { key: "unit", label: "단위", align: "center" },
    { key: "qty", label: "입고수량", align: "right" },
    { key: "remark", label: "비고" },
  ];

  return (
    <div className="space-y-6">
      {/* ===============================
          Header Info
      =============================== */}
      <table className="doc-table w-full text-sm">
        <tbody>
          <tr>
            <TableCell
              label="출처 PO"
              colSpan={3}
              value={header.from_po_dns || "-"}
            />
          </tr>
          <tr>
            <TableCell label="입고일" value={fmtDate(header.in_date)} />
            <TableCell label="공급업체" value={header.supplier || "-"} />
          </tr>
          <tr>
            <TableCell label="비고" value={header.remark || "-"} />
            <TableCell label="통화" value={header.currency || "KRW"} />
          </tr>
        </tbody>
      </table>

      {/* ===============================
          Item Table
      =============================== */}
      <table className="doc-table w-full text-sm mt-4">
        <thead className="doc-thead">
          <tr>
            {columns.map((c, idx) => (
              <th
                key={c.key}
                className={idx === columns.length - 1 ? "doc-th-end" : "doc-th"}
                style={{
                  textAlign:
                    c.align === "right"
                      ? "right"
                      : c.align === "center"
                      ? "center"
                      : "left",
                }}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {items.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="doc-td text-center text-gray-400 py-4"
              >
                항목이 없습니다.
              </td>
            </tr>
          ) : (
            items.map((row, idx) => (
              <tr key={idx}>
                {columns.map((c) => (
                  <td
                    key={c.key}
                    className={`doc-td ${
                      c.align === "right"
                        ? "text-right"
                        : c.align === "center"
                        ? "text-center"
                        : ""
                    }`}
                  >
                    {c.key === "qty"
                      ? Number(row.qty || 0).toLocaleString()
                      : row[c.key] ?? ""}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
